import React from 'react';
import { createRoot } from 'react-dom/client';
import WebApp from './WebApp';

// 전역 플래그: shortcode 번들이 정상 로드되었음을 표시
// PHP 쪽에서 이 값을 보고, 로드 실패 시 한 번만 새로고침합니다.
if (typeof window !== 'undefined') {
  window.__RM_SHORTCODE_JS_LOADED = true;
}

function mount() {
  const el = document.getElementById('rm-root');

  const app = <WebApp />;
  createRoot(el).render(app);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}

if (import.meta && import.meta.webpackHot) {
  import.meta.webpackHot.accept();
}